import { render, staticRenderFns } from "./AnimationIssueItem.vue?vue&type=template&id=57a6d4ba&"
import script from "./AnimationIssueItem.vue?vue&type=script&lang=js&"
export * from "./AnimationIssueItem.vue?vue&type=script&lang=js&"
import style0 from "./AnimationIssueItem.vue?vue&type=style&index=0&id=57a6d4ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports